import { useCallback, useRef, useState } from "react";

/**
 * Hook for managing tooltip menu states and interactions
 */
export const useTooltipMenu = (isSmall, isMenuOpen) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [tooltipAnchorEl, setTooltipAnchorEl] = useState(null);
  const closeMenuTimerRef = useRef(null);

  const handleMenuItemHover = useCallback(
    (event, item) => {
      if (!isSmall && !isMenuOpen) {
        if (closeMenuTimerRef.current) {
          clearTimeout(closeMenuTimerRef.current);
          closeMenuTimerRef.current = null;
        }

        if (hoveredItem !== item) {
          setHoveredItem(item);
          setTooltipAnchorEl(event.currentTarget);
        }
      }
    },
    [isSmall, isMenuOpen, hoveredItem]
  );

  const handleMenuItemLeave = useCallback(() => {
    closeMenuTimerRef.current = setTimeout(() => {
      setHoveredItem(null);
      setTooltipAnchorEl(null);
    }, 200);
  }, []);

  const handlePopperMouseEnter = useCallback(() => {
    if (closeMenuTimerRef.current) {
      clearTimeout(closeMenuTimerRef.current);
      closeMenuTimerRef.current = null;
    }
  }, []);

  return {
    hoveredItem,
    tooltipAnchorEl,
    handleMenuItemHover,
    handleMenuItemLeave,
    handlePopperMouseEnter,
  };
};
